import { ReactNode } from "react";
import { List } from "../common/List";

import './FooterColumn.scss';

export interface FooterColumnProps {
    children: ReactNode;
    classes?: string;
}

export const FooterColumn = ({ children, classes }: FooterColumnProps) => (
    <div className={`footer__column ${classes ?? ''}`}>
        {children}
    </div>
);

export interface FooterLinksColumnProps {
    children: ReactNode;
    classes?: string;
    heading: string;
}

export const FooterLinksColumn = ({ children, classes, heading }: FooterLinksColumnProps) => (
    <FooterColumn classes={classes}>
        <h2 className="footer__column-header">
            {heading}
        </h2>

        <List heading={heading} className="footer__column-links">
            {children}        
        </List>
    </FooterColumn>
);
